import { AfterViewInit, Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { EMilieuPrelevementAir } from 'src/app/domain/Air/enum/milieu-prelevement';
import { EConditionPrelevement } from 'src/app/domain/enums/condition-prelevement';
import { Zone } from 'src/app/domain/zone';

import { Intervention } from 'src/app/domain/intervention';
import { ENavigationRoute } from 'src/app/models/enums/navigation-route';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppareilRepository } from 'src/app/db/repository/appareil.repository';
import { EndoscopeRepository } from 'src/app/db/repository/endoscope.repository';
import { GenerateurRepository } from 'src/app/db/repository/generateur.repository';
import { InterventionRepository } from 'src/app/db/repository/intervention.repository';
import { ZoneRepository } from 'src/app/db/repository/zone.repository';
import { Generateur } from 'src/app/domain/Dialyse/generateur';
import { Endoscope } from 'src/app/domain/Endoscope/endoscope';
import { ETypeAppareil } from 'src/app/domain/Qualif/enums/type-appareil';
import { ETaskStatus } from 'src/app/models/enums/task-status';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/loading-task';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { StringConverter } from 'src/app/tools/ui/string-converter';

@Component({
    selector: 'app-intervention',
    templateUrl: './intervention.component.html',
    styleUrl: './intervention.component.scss',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatSlideToggleModule, FormsModule, MatInputModule]
})
export class InterventionComponent implements OnInit, AfterViewInit {
    ETypeAppareil = ETypeAppareil;

    private interventionCode: string = '';
    Intervention!: Intervention;
    FilteredIntervention?: Intervention;
    checked: boolean = true;
    showAppareil: boolean = true;
    SearchText: string = ''

    constructor(

        public loadingTask: LoadingTask,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private coreData: CoreData,
        private router: Router,

        private interventionRepository: InterventionRepository,
        private zoneRepository: ZoneRepository,
        private generateurRepository: GenerateurRepository,
        private endoscopeRepository: EndoscopeRepository,
        private appareilRepository: AppareilRepository) { }

    ngOnInit(): void {

    }

    async ngAfterViewInit(): Promise<void> {

        this.interventionCode = this.route.snapshot.params['interventionCode'];
        this.Intervention = await this.interventionRepository.getInterventionByCode(this.interventionCode!);
        this.FilteredIntervention = Object.assign({}, this.Intervention)

        this.checked = this.coreData.WithDone

        this.coreData.CurrentPageName = this.Intervention.NomChantier;

        // if (!this.checked) {

        //     this.Intervention.GenerateurDialyseList = this.Intervention.GenerateurDialyseList.filter(x => x.TaskStatus !== ETaskStatus.Done)
        //     this.Intervention.EndoscopeList = this.Intervention.EndoscopeList.filter(x => x.TaskStatus !== ETaskStatus.Done)
        //     this.Intervention.ZoneList = this.Intervention.ZoneList.filter(x => x.TaskStatus !== ETaskStatus.Done)
        // }
        this.search();
    }

    hasSurfaceIntervention() {
        if (this.Intervention && this.Intervention.ZoneList.map(x => x.PrelevementSurfaceList).flat().length > 0)
            return true
        return false;
    }

    hasAirIntervention() {
        if (this.Intervention && this.Intervention.ZoneList.map(x => x.PrelevementAirList).flat().length > 0)
            return true
        return false;
    }

    hasQualifIntervention() {
        if (this.Intervention && this.Intervention.ZoneList.some(x => x.PrelevementQualifSalle))
            return true
        return false;
    }



    async change(event: MatSlideToggleChange) {
        // this.loadingTask.activateLoading();
        this.checked = event.checked;
        // if (event.checked) {
        //     this.Intervention = await db.getInterventionByCode(this.interventionCode!);
        // } else {
        //     this.Intervention.GenerateurDialyseList = this.Intervention.GenerateurDialyseList.filter(x => x.TaskStatus !== ETaskStatus.Done)
        //     this.Intervention.EndoscopeList = this.Intervention.EndoscopeList.filter(x => x.TaskStatus !== ETaskStatus.Done)
        //     this.Intervention.ZoneList = this.Intervention.ZoneList.filter(x => x.TaskStatus !== ETaskStatus.Done)
        // }
        this.coreData.WithDone = event.checked;
        // this.loadingTask.deactivateLoading();
        this.search();
    }

    getMockedData() {

    }

    getConditionPrelevementLabel(cond: EConditionPrelevement) {
        return StringConverter.getConditionPrelevement(cond)
    }

    getMilieuPrelevementLabel(milieu: EMilieuPrelevementAir) {
        return StringConverter.getMilieuPrelevement(milieu)
    }

    // openDispatchComment() {
    //     this.dialog.open(ConfirmBoxDialog, {
    //         data: {
    //             message: `${this.Intervention.Comment}`
    //         },
    //         width: '777px',
    //     });
    // }

    async navigateToZone(zone: Zone) {
        if (zone.TaskStatus !== ETaskStatus.Done) {
            zone.TaskStatus = ETaskStatus.InProgress;
            await this.zoneRepository.changeZoneTaskStatus(zone);
        }
        this.router.navigate([ENavigationRoute.Zone, { zoneCode: zone.Code }]);
    }

    async navigateToAppareil(gen: Generateur) {
        if (gen.TaskStatus !== ETaskStatus.Done) {
            gen.TaskStatus = ETaskStatus.InProgress;
            await this.generateurRepository.changeGenerateurTaskStatus(gen);
        }
        this.router.navigate([ENavigationRoute.Generateur, { appCode: gen.Code }]);
    }

    async navigateToEndoscope(endoscope: Endoscope) {
        if (endoscope.TaskStatus !== ETaskStatus.Done) {
            endoscope.TaskStatus = ETaskStatus.InProgress;
            await this.endoscopeRepository.changeEndoscopeTaskStatus(endoscope);
        }
        this.router.navigate([ENavigationRoute.Endoscope, { endoCode: endoscope.Code }]);
    }

    async clearFilter() {
        this.loadingTask.activateLoading()
        this.SearchText = '';
        this.FilteredIntervention = Object.assign({}, this.Intervention)
        this.loadingTask.deactivateLoading();
    }

    search() {
        this.FilteredIntervention!.EndoscopeList = this.Intervention.EndoscopeList.filter(x =>
            (!StringTool.isNotNullOrEmpty(this.SearchText) || x.ZoneSalle.toLowerCase().includes(this.SearchText.toLowerCase())) &&
            (x.TaskStatus === ETaskStatus.InProgress || x.TaskStatus === ETaskStatus.New ||
                (this.checked && x.TaskStatus === ETaskStatus.Done)))
        this.FilteredIntervention!.GenerateurDialyseList = this.Intervention.GenerateurDialyseList.filter(x =>
            (!StringTool.isNotNullOrEmpty(this.SearchText) || x.ZoneSalle.toLowerCase().includes(this.SearchText.toLowerCase())) &&
            (x.TaskStatus === ETaskStatus.InProgress || x.TaskStatus === ETaskStatus.New ||
                (this.checked && x.TaskStatus === ETaskStatus.Done)))
        this.FilteredIntervention!.ZoneList = this.Intervention.ZoneList.filter(x =>
            (!StringTool.isNotNullOrEmpty(this.SearchText) || x.ZoneSalle.toLowerCase().includes(this.SearchText.toLowerCase())) &&
            (x.TaskStatus === ETaskStatus.InProgress || x.TaskStatus === ETaskStatus.New ||
                (this.checked && x.TaskStatus === ETaskStatus.Done)))
    }

    getColorByPrelevementType(instance: Zone | Generateur | Endoscope) {

        switch (instance.TaskStatus) {
            case ETaskStatus.New:
                return "red !important"
            case ETaskStatus.InProgress:
                return "orange !important";
            case ETaskStatus.Done:
                return "green !important";
        }
        return "grey";
    }

    // getAppareilFromIntervention(type: ETypeAppareil) {
    //     switch (type) {
    //         case ETypeAppareil.Biocollecteur:
    //             return this.Intervention.Biocollecteur;
    //         case ETypeAppareil.ApplicateurContact:
    //             return this.Intervention.ApplicateurContact;
    //         case ETypeAppareil.Compteur:
    //             return this.Intervention.Compteur;
    //         case ETypeAppareil.Multimetre:
    //             return this.Intervention.Multimetre;
    //         default:
    //             return;
    //     }

    // }


}
